import "@shared/assets/styles/common.css"
import "@shared/assets/styles/vod.common.custom.css"
import "@shared/assets/styles/vod_common.css"

import React from "react"

import { MetaData } from "@shared/components"
import { Notice } from "@shared/components/layerPopups"
import { LayerPopupProvider } from "@shared/contexts"
import { ChatProvider } from "@shared/contexts"
import { ScheduleProvider } from "@shared/contexts"
import { useAppierVodEvent, useCriteo, useCRM } from "@shared/hooks"

import { Vod } from "vod/components"
import { VodPlayerProvider, VodsProvider } from "vod/contexts"

function VodPage() {
  useCriteo()
  useCRM()
  useAppierVodEvent()

  return (
    <LayerPopupProvider>
      <ChatProvider>
        <Notice targetPlayer="VOD" />
        <MetaData />
        <VodsProvider>
          <VodPlayerProvider>
            <Vod />
          </VodPlayerProvider>
        </VodsProvider>
      </ChatProvider>
    </LayerPopupProvider>
  )
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <VodPage />
  </ScheduleProvider>
)
